<template>
    <div class="app-container">
      <BjDivider right-fixed>{{ $t('AccountManagementAdd.customerInfo.titile') }}
          <template #right>
            <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="submit">{{ $t('okText') }}</el-button>
            <BjLogButton v-if="isEdit" :id="recordId" no-permission :title="form.realName" api="roleApi" />
          </template>
      </BjDivider>
      <!-- 账户基础信息 -->
      <el-form ref="queryForm" :rules="rules" :model="form" label-width="150px" label-position="top">
        <el-row :gutter="20">
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.account')" prop="loginName">
              <BjInput v-model="form.loginName" :maxlength="20" :disabled="isEdit" :placeholder="$t('AccountManagementAdd.place')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.name')" prop="realName">
              <BjInput v-model="form.realName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.Nickname')" prop="nickname">
              <BjInput v-model="form.nickname" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col> -->
          <el-col :span="colSpan">
            <BjFormItemMobile v-model="form.phone" prop="phone" :maxlength="20" :label="$t('AccountManagementAdd.phone')" clearable />
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.email')" prop="email">
              <BjInput v-model="form.email" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col v-if="!isEdit" :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.password')" prop="password">
              <BjInput v-model="form.password" :maxlength="MAX_LENGTH.DEFAULT" :disabled="isEdit" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.from')" prop="startDateActive">
              <BjDatePicker v-model="form.startDateActive" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.until')" prop="endDateActive">
              <BjDatePicker v-model="form.endDateActive" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 客户基础信息 -->
        <BjDivider right-fixed>{{ $t('AccountManagementAdd.customerInfo.titile2') }}</BjDivider>
        <el-row :gutter="20">
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.clientCode')" prop="customerInfo.clientCode">
              <BjInputCode v-model="form.customerInfo.clientCode" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.clientFullName')" prop="clientFullName">
              <BjInput v-model="form.customerInfo.clientFullName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col> -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.bpCode')" prop="customerInfo.bpCode">
              <BjInputCode v-model="form.customerInfo.bpCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CSGSales')">
              <BjSelectLov v-model="form.customerInfo.csgSales" :option-list="csgSalesList" :placeholder="$t('chooseText')"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CSGCustomerService')" prop="csgCustomer">
              <BjSelectLov v-model="form.customerInfo.csgCustomer" :option-list="customerNameList" :placeholder="$t('chooseText')"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CustomerType')" prop="customerInfo.customerType">
              <BjSelectLov v-model="form.customerInfo.customerType" :placeholder="$t('AccountManagementAdd.customerInfo.CustomerType')" :option-list="USER_CUSTOMER_TYPE_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.ContactPerson')" prop="customerInfo.contactPerson">
              <BjInput v-model="form.customerInfo.contactPerson" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.ContactPhoneNumber')" prop="customerInfo.billingAddressPhone">
              <BjInputNumber v-model="form.customerInfo.billingAddressPhone" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.industry')">
              <BjSelectLov v-model="form.customerInfo.industry" :option-list="industryList" :placeholder="$t('AccountManagementAdd.customerInfo.industry')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 客户公司信息 -->
        <BjDivider>{{ $t('AccountManagementAdd.customerInfo.CompanyInformation') }}</BjDivider>
        <el-row :gutter="20">
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CompanyName')" prop="customerInfo.companyName">
              <BjInput v-model="form.customerInfo.companyName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.abn')" prop="customerInfo.auBusinessNumber">
              <BjInputNumber v-model="form.customerInfo.auBusinessNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.weburl')">
              <BjInput v-model="form.customerInfo.companyWebsite" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.GeneralEmail')" prop="customerInfo.generalEmail">
              <BjInput v-model="form.customerInfo.generalEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.BillEmail')" prop="customerInfo.billingAddressEmail">
              <BjInput v-model="form.customerInfo.billingAddressEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.FinancialEmail')">
              <BjInput v-model="form.customerInfo.financialEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col> -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CustomerServiceEmail')">
              <BjInput v-model="form.customerInfo.customerEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CompanyAddress')">
              <BjInput v-model="form.customerInfo.billingAddress2" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.generalEmailOther')" prop="customerInfo.generalEmailOther">
              <BjTextarea v-model="form.customerInfo.generalEmailOther" :rows="2" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('AccountManagementAdd.tips')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.BillEmailOther')" prop="customerInfo.billingAddressEmailOther">
              <BjTextarea v-model="form.customerInfo.billingAddressEmailOther" :rows="2" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('AccountManagementAdd.tips')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CustomerServiceEmailOther')" prop="customerInfo.customerEmailOther">
              <BjTextarea v-model="form.customerInfo.customerEmailOther" :rows="2" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('AccountManagementAdd.tips')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 客户账单信息 -->
        <BjDivider>{{ $t('AccountManagementAdd.customerInfo.billingInformation') }}</BjDivider>
        <el-row :gutter="20">
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.AccountingPeriod')" prop="customerInfo.paymentTerm">
              <BjInputNumber v-model="form.customerInfo.paymentTerm" :disabled="$route.query.pageType != 'canEdit'" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.CreditLimit')" prop="customerInfo.creditLimit">
              <BjInputNumber v-model="form.customerInfo.creditLimit" :disabled="$route.query.pageType != 'canEdit'" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.isNom')" prop="customerInfo.isNom">
              <BjSelectLov v-model="form.customerInfo.isNom" :option-list="NOM_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.ifLocal')" prop="customerInfo.ifLocal">
              <BjSelectLov v-model="form.customerInfo.ifLocal" :option-list="STATUS_YES_TRUE" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.currencySymbol')" prop="customerInfo.currencySymbol">
              <BjSelectLov v-model="form.customerInfo.currencySymbol" lov-code="CHANNEL_CURRENCY" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddress')" prop="customerInfo.billingAddress1">
              <BjInput v-model="form.customerInfo.billingAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.palletAccount')">
              <BjInput v-model="form.customerInfo.palletAccount" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.deposit')">
              <BjInputMoney v-model="form.customerInfo.deposit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 角色 -->
      <BjDivider>{{ $t('AccountManagementAdd.Role') }}</BjDivider>
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="danger" icon="el-icon-delete" :disabled="multiple" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" @click="onAdd">{{ $t('AccountManagementAdd.Add') }}</el-button>
        </el-col>
      </el-row>
      <el-table v-loading="loading" :data="roleTableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column :label="$t('AccountManagementAdd.RoleName')" align="center" prop="name" />
        <el-table-column :label="$t('AccountManagementAdd.TenantName')" align="center" prop="tenantName" />
        <el-table-column :label="$t('AccountManagementAdd.from')" align="center" prop="name" width="250">
          <template slot-scope="scope">
            <BjDatePicker v-model="scope.row.startDateActive" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('AccountManagementAdd.until')" align="center" prop="name" width="250">
          <template slot-scope="scope">
            <BjDatePicker v-model="scope.row.endDateActive" />
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.size" />

      <BjDialogList ref="dialogList" :config="dialogListConfig" :disabled="disabledIds" multiple @confirm="onConfirmDialogList" />
    </div>
  </template>
  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  import { roleApi,userApi,billApi } from '@/api';
  import {GENDER_LIST, STATUS_YES_TRUE, USER_CUSTOMER_TYPE_LIST} from '@/utils/constants';
  import { parseTime } from '@/utils';
  import BjInputNumber from '@/packages/BjInputNumber';
  import BjFormItemMobile from '@/components/BjFormItemMobile';
  import { validatePass } from '@/utils';

  export default {
    name: 'ViewForm',
    components: {BjFormItemMobile, BjInputNumber},
    mixins: [viewMiXin],
    props: {
      isEdit: {
        type: Boolean,
        default: false,
      },
      userInfo: {
        type: Object,
        default() {
          return null;
        },
      },
      userAllRoles: {
        type: Array,
        default() {
          return [];
        },
      },
      /** 公司 ids */
      companyLists: {
        type: Array,
        default() {
          return [];
        },
      },
      isCustomer: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        STATUS_YES_TRUE,
        USER_CUSTOMER_TYPE_LIST,
        colSpan: 4,
        pageName: 'BusinessUserAccountIndex',
        dialogListConfig: {
          title: this.$t('AccountManagementAdd.Add'),
          columns: [
            {
              prop: 'name',
              label: this.$t('AccountManagementAdd.RoleName'),
            },
            {
              prop: 'tenantName',
              label: this.$t('AccountManagementAdd.TenantName'),
            },
          ],
          search: [
            {
              placeholder: this.$t('AccountManagementAdd.ps'),
              key: 'name',
            },
          ],
          actionApi: roleApi.getRoleList,
          defaultQuery: {
            enabled: true,
            belongTo: this.$store.getters.cusId ? 2:1
          },
          query: '',
        },
        // 遮罩层
        loading: false,
        // 查询参数
        queryParams: {},
        title: '',
        dialogVisible: false,
        // 选中数组ids
        ids: [],
        // 选中数组
        selection: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        /** 数据总条数 */
        total: 0,
        // 日志查询参数
        recordId: null,
        NOM_LIST: [
          { value: false, label: 'NET' },
          { value: true, label: 'EOM' },
        ],
        // 客服下拉列表
        customerNameList:[],
        // 行业下拉列表
        industryList:[],
        // 表单参数
        form: {
          enabled: true,
          realName: null,
          deptAbbr: null,
          internationalTelCode: null,
          loginName: null,
          nickname: null,
          password: null,
          phone: null,
          email: null,
          gender: null,
          countryCode: null,
          countryName: null,
          regionId: null,
          addressDetail: null,
          birthday: null,
          startDateActive: null,
          endDateActive: null,
          // userType: null, // 用户类型（暂时用不到）
          memberRoleList: [],
          companyLists: [], // 组织架构 id
          customerInfo: {
            billingAddress1: null,
            billingAddress2: null, // 公司地址
            billingAddressCity: null,
            billingAddressCountry: null,
            billingAddressEmail: null, // 账单邮箱
            billingAddressPhone: null, // 联系电话
            billingAddressPostcode: null,
            billingAddressState: null,
            billingAddressUnit: null,
            bpCode: null,
            clientCode: null,
            clientFullName: null,
            companyEnName: null,
            companyName: null, // 公司名称
            contactPerson: null, // 联系人
            currencySymbol: null,
            ifLocal: null,
            isNom: null,
            paymentTerm: null, // 账期
            industry: null, // 行业类型

            csgSales: null, // CSG销售
            csgCustomer: null, // CSG客服
            customerType: null, // 客户类型
            auBusinessNumber: null, // 澳大利亚商务号码
            companyWebsite: null, // 公司网站
            generalEmail: null, // 通用邮箱
            financialEmail: null, // 财务邮箱
            customerEmail: null, // 客服邮箱
            creditLimit: null, // 信用额度
            paymentTerms: null, // 月结时间
            palletAccount: null // 托盘账户
          }
        },
        roleTableData: [],
        disabledIds: [],
        GENDER_LIST,
        csgSalesList: []
      };
    },
    computed: {
      rules() {
        const validateEmailAddress = (rule, value, callback) => {
          this.$nextTick(() => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!value) {
              callback(new Error(this.$t('emptyWarningText')));
            }
            if (!emailRegex.test(value)) {
              callback(new Error(this.$t('formatErrorText')));
            }
            callback();
          });
        };
        const validateTime = (rule, value, callback) => {
          this.$nextTick(() => {
            if (!value) {
              callback(new Error(this.$t('emptyWarningText')));
            }
            if(this.form.endDateActive){
              if (new Date(this.form.endDateActive).getTime() <= new Date(this.form.startDateActive).getTime()) {
                callback(new Error(this.$t('AccountManagementAdd.ValidPS')));
              }
            }
            callback();
          });
        };
        return {
          // Account Information
          loginName: [{ required: true, trigger: 'blur', validator: this.validateLoginName }],
          realName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          password: [{ required: true, validator: validatePass, trigger: 'blur' }],
          startDateActive: [{ required: true, validator: validateTime, trigger: 'blur' }],
          // Customer Information
          'customerInfo.clientCode': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.bpCode': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.customerType': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          'customerInfo.contactPerson': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.billingAddressPhone': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          // Company Information
          'customerInfo.companyName': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.auBusinessNumber': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.generalEmail': { required: true, validator: validateEmailAddress, trigger: 'blur' },
          'customerInfo.billingAddressEmail': { required: true, validator: validateEmailAddress, trigger: 'blur' },
          // Billing Information
          'customerInfo.paymentTerm': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.creditLimit': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          'customerInfo.isNom': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          'customerInfo.ifLocal': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          'customerInfo.currencySymbol': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          'customerInfo.billingAddress1': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        };
      },
      isCustomerShow() {
        return this.isCustomer || this.form.customerInfo?.cusId;
      },
    },
    watch: {
      userInfo: {
        handler(info) {
          if (info) {
            if(this.$route.query.onboardingId){
              this.form.email = info.email;
              this.form.loginName = info.loginName;
              this.form.password = info.password;
              this.form.phone = info.phone;
              this.form.realName = info.realName;
              this.form.customerInfo = {...this.form.customerInfo,...info.customerInfo};
            }else{
              this.recordId = info.id;
              this.form.enabled = info.enabled;
              this.form.realName = info.realName;
              this.form.loginName = info.loginName;
              this.form.nickname = info.nickname;
              this.form.internationalTelCode = info.internationalTelCode;
              this.form.phone = info.phone;
              this.form.email = info.email;
              this.form.gender = info.gender;
              this.form.countryName = info.countryName;
              this.form.regionId = info.regionId;
              this.form.addressDetail = info.addressDetail;
              this.form.birthday = info.birthday;
              this.form.startDateActive = info.startDateActive;
              this.form.endDateActive = info.endDateActive;
              this.form.deptAbbr = info.deptAbbr;
              this.form.customerInfo = info.customerInfo;
            }
          }
        },
      },
      userAllRoles: {
        handler(roles) {
          console.log(roles,'roles')
          if (roles) {
            if(this.$route.query.onboardingId){
              this.roleTableData = [].concat(roles);
            }else{
              this.roleTableData = [].concat(roles);
            }
          }
        },
      },
      companyLists: {
        handler(list) {
          this.form.companyLists = list;
        },
      },
    },
    created() {
      this.getCustomerList();
      this.getIndustryList();
      if (!this.isEdit) this.form.startDateActive = parseTime(new Date(), '{y}-{m}-{d}');  
    },
    methods: {
      // 获取客服下拉数据
      getCustomerList(){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
          if(res.content.length){
            this.customerNameList = res.content.map(item => {
              return { label: item.realName, value: item.realName };
            });
            userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Sales'}).then(resp=>{
              if(resp.content.length){
                this.csgSalesList = resp.content.map(item => {
                  return { label: item.realName, value: item.realName };
                });
              }
            })
          }
        })
      },
      // 获取行业类型下拉数据
      getIndustryList(){
        billApi.getCustomerType({dataModel:2}).then(res=>{
          if(res.data.content.length){
            this.industryList = res.data.content.map(item => {
              return { label: item.industry, value: item.industry };
            });
          }
        })
      },
      validateLoginName(rule, value, callback) {
        if (rule.required && (!value || value === 0)) {
          callback(new Error(this.$t('PleaseAccountText')));
        } else {
          if (!/^[\u4e00-\u9fa5a-zA-Z0-9\s,.?!]{2,20}$/.test(value)) {
            callback(new Error(this.$t('PleaseCorrectAccountText')));
          } else {
            callback();
          }
        }
      },
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.id);
        this.selection = selection;
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 选择国家清空地区数据 */
      handleChangeCountry(id, data) {
        this.form.countryCode = data.countryCode;
        this.form.regionId = null;
      },
      /** 选择组织架构 */
      onChangeCompany(data, node) {
        // 获取选中组织架构ids
        this.form.companyLists = node.checkedKeys;
      },
      regexEmail(input){
        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
        const emailsOne = emailRegex.test(input);
        if (emailsOne) {
            const emailsTwo = input.match(emailRegex);
            return emailsTwo.join(';');
        } else {
            return false
        }
      },
      /** 提交 */
      submit() {
        if (!this.roleTableData.length) {
          this.$message.warning(this.$t('AccountManagementAdd.ps3'));
          return;
        }
        if(this.form.customerInfo.generalEmailOther){
          if(!this.regexEmail(this.form.customerInfo.generalEmailOther)){
            return this.$message.warning(this.$t('AccountManagementAdd.customerInfo.generalEmailOther')+this.$t('formatErrorText'));
          }else{
            this.form.customerInfo.generalEmailOther = this.regexEmail(this.form.customerInfo.generalEmailOther)
          }
        }
        if(this.form.customerInfo.billingAddressEmailOther){
          if(!this.regexEmail(this.form.customerInfo.billingAddressEmailOther)){
            return this.$message.warning(this.$t('AccountManagementAdd.customerInfo.BillEmailOther')+this.$t('formatErrorText'));
          }else{
            this.form.customerInfo.billingAddressEmailOther = this.regexEmail(this.form.customerInfo.billingAddressEmailOther)
          }
        }
        if(this.form.customerInfo.customerEmailOther){
          if(!this.regexEmail(this.form.customerInfo.customerEmailOther)){
            return this.$message.warning(this.$t('AccountManagementAdd.customerInfo.CustomerServiceEmailOther')+this.$t('formatErrorText'));
          }else{
            this.form.customerInfo.customerEmailOther = this.regexEmail(this.form.customerInfo.customerEmailOther)
          }
        }
        // 判断是否是客户
        if (this.isCustomerShow) {
        //   this.$refs['customerForm'].validate(valid => {
        //     if (!valid) return this.$scrollToFormError();
            this.$refs['queryForm'].validate(valid => {
              if (!valid) return this.$scrollToFormError();
              this.form.memberRoleList = this.roleTableData.map(e => {
                return {
                  _innerMap: {},
                  roleId: e.id,
                  startDateActive: e.startDateActive,
                  endDateActive: e.endDateActive,
                };
              });
              this.$emit('submit', this.form);
            });
        //   });
        } else {
          this.$refs['queryForm'].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          this.form.memberRoleList = this.roleTableData.map(e => {
            return {
              _innerMap: {},
              roleId: e.id,
              startDateActive: e.startDateActive,
              endDateActive: e.endDateActive,
            };
          });
          this.$emit('submit', this.form);
        });
        }
      },
      /**
       * START 添加角色操作
       */
      onAdd() {
        this.disabledIds = this.roleTableData.map(item => {
          return item.id;
        });
        this.$refs.dialogList.show();
      },
      onConfirmDialogList(data) {
        if (this.isEdit) {
          this.$emit('addUserRoles', data.map(e => e.id));
        } else {
          data.forEach(element => {
            if (this.roleTableData.every(e => e.id != element.id)) {
              this.roleTableData.push({
                startDateActive: null,
                endDateActive: null,
                ...element,
              });
            }
          });
        }
      },
      /** END */
      /** 编辑操作 */
      onEdit() {
        this.title = this.$t('AccountManagementAdd.ps4');
        this.dialogVisible = true;
      },
      /** 删除操作 */
      onDeleteSelected() {
        const name = this.selection
          .map(item => {
            return item.name;
          })
          .join('，');
        this.$confirm(
          this.$t('AccountManagementAdd.ps5') +
            ' ' +
            name +
            ' ' +
            this.$t('AccountManagementAdd.ps6'),
          this.$t('AccountManagementAdd.ps7'),
          {
            confirmButtonText: this.$t('okText'),
            cancelButtonText: this.$t('cancelText'),
            type: 'warning',
            dangerouslyUseHTMLString: true,
          },
        )
          .then(() => {
            if (this.isEdit) {
              this.$emit('deleteUserRoles', this.ids);
            } else {
              this.ids.forEach(id => {
                const findIndex = this.roleTableData.findIndex(e => e.id == id);
                if (findIndex !== -1) {
                  this.roleTableData.splice(findIndex, 1);
                }
              });
            }
          })
          .catch(() => {});
      },
    },
  };
  </script>
  <style scoped></style>
